// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-create-dialog',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    props: {
        cartName: {
            type: String,
            required: false,
            default: null
        },
        cartID: {
            type: String,
            required: false,
            default: ''
        },
        cartType: {
            type: String,
            required: false,
            default: null,
        },
        callback: {
            type: Function,
            required: false
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        cartNameInternal: '',
        comment: '',
        addresses: {
            delivery: {
                mode: 'Custom',
                country: 'DE'
            }
        }
    }),
    // #endregion
    // #region Boostrap
    created() {
        this.cartNameInternal = this.cartName ?? this.$tc(`client.Commerce.${this.cartType === 'L' ? 'OrderLists' : 'Carts'}.DefaultName`, { timestamp: new Date().toLocaleString() });
    },
    // #endregion
    // #region Methods
    methods: {
        onCreate() {
            // #region Check
            if (!this.$refs['frmMain'].$form.validate()) {
                return;
            }
            // #endregion
            // #region Update
            if (this.cartID) {
                // #region Args
                let tCart = {
                    cartName: this.cartNameInternal
                };
                // #endregion
                // #region Send
                host.api.patch(`commerce/carts/${this.cartID}`, tCart)
                    .then(e => {
                    // #region Store
                    this.$store.commit('carts/load');
                    // #endregion
                    // #region Close
                    this.currentWindow.close(1);
                    // #endregion
                    // #region Callaback
                    if (this.callback) {
                        this.callback();
                    }
                    // #endregion
                })
                    .catch(e => {
                    host.notification.showToast(utils.getAxiosErrorMessage(e));
                });
                // #endregion
            }
            // #endregion
            // #region New
            else {
                // #region Args
                let tCart = {
                    accountID: this.$host.store.getter("session/accountID"),
                    userID: this.$host.store.getter("session/userID"),
                    cartName: this.cartNameInternal,
                    cartType: this.cartType,
                    comment: this.comment
                };
                if (this.cartType === 'L') {
                    tCart.addresses = this.addresses;
                }
                // #endregion
                // #region Send
                host.api.post('commerce/carts', tCart)
                    .then(e => {
                    // #region Store
                    this.$store.commit('carts/load');
                    // #endregion
                    // #region Close
                    this.currentWindow.close(1);
                    // #endregion
                    // #region Callaback
                    if (this.callback) {
                        this.callback();
                    }
                    // #endregion
                })
                    .catch(e => {
                    host.notification.showToast(utils.getAxiosErrorMessage(e));
                });
                // #endregion
            }
            // #endregion
        }
    }
    // #endregion
});
// #endregion
